import { createApp } from 'vue'
import { ObserveVisibility } from 'vue-observe-visibility'
import ModelSearch from './ModelSearch.vue'
import DistributorSearch from './DistributorSearch.vue'

const searchApp = createApp(ModelSearch)
searchApp.directive('observe-visibility', {
  beforeMount: (el, binding, vnode) => {
    vnode.context = binding.instance
    ObserveVisibility.bind(el, binding, vnode)
  },
  update: ObserveVisibility.update,
  unmounted: ObserveVisibility.unbind
})
window.vuesearchapp = searchApp

const distributorSearchApp = createApp(DistributorSearch)
window.vuedistributorsearchapp = distributorSearchApp
